export const CLIENT_MESSAGES = {
    PLAY_CARDS: 'play_cards',
    PASS: 'pass',
    CALL_REVOLUTION: 'call_revolution',
    DECLINE_REVOLUTION: 'decline_revolution',
    SUBMIT_TAX: 'submit_tax',
    CHAT: 'chat',
    READY: 'ready',
    // Pre-game lobby (waiting room) controls
    ADD_BOT: 'add_bot',
    REMOVE_SEAT: 'remove_seat',
    UPDATE_ROOM_OPTIONS: 'update_room_options',
    START_GAME: 'start_game',
    KICK_PLAYER: 'kick_player',
    // Global lobby
    CREATE_ROOM: 'create_room',
    GLOBAL_CHAT: 'global_chat',
    // Client signals it's mounted into GameScene and ready to receive the
    // current hand + state. Used to recover from RoomScene→GameScene races
    // where the initial HAND_UPDATE arrived while RoomScene was still active.
    REQUEST_GAME_STATE: 'request_game_state',
    // A seated human asks the server to fast-forward the remaining bot-only
    // endgame (only valid once every human has finished the round).
    SKIP_BOTS: 'skip_bots',
};
export const SERVER_MESSAGES = {
    ERROR: 'error',
    CHAT: 'chat',
    GAME_LOG: 'game_log',
    HAND_UPDATE: 'hand_update',
    PLAY_EVENT: 'play_event',
    PASS_EVENT: 'pass_event',
    TRICK_CLEAR: 'trick_clear',
    ROOM_STATE: 'room_state',
    // Global lobby
    LOBBY_STATE: 'lobby_state',
    GLOBAL_CHAT: 'global_chat',
    ROOM_CREATED: 'room_created',
};
